import styled from "styled-components";

const CheckoutStepsContainer = styled.div`
    .after-header {
        .check {
            height: 33px;
            width: 33px;
            border: 1px solid #333;
            border-radius: 50%;
            margin-top: 5px;
        }
    }

    .form-content {
        input,
        select,
        textarea {
            width: 100%;
            line-height: 2;
            padding: 8px 10px;
            background: #fdfdfd;
            border: solid 1px #cccc;
            border-radius: 5px;
            margin-bottom: 20px;
            font-size: 16px;
            &.disabled {
                pointer-events: none !important;
            }
        }
        input,
        select {
            height: 48px;
        }
        input[type="checkbox"],
        input[type="radio"] {
            height: 15px;
            width: 15px;
            margin-bottom: 0px;
            &:not(:last-child) {
                margin-bottom: 18px;
            }
            + span {
                top: -1.5px;
            }
        }

        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        input[type="number"] {
            -moz-appearance: textfield;
        }

        .form-lt,
        .form-rt,
        .form-ct {
            margin-bottom: 20px;
            > input,
            > select,
            > textarea {
                margin-bottom: 0;
            }
        }
        .form-lt,
        .form-rt {
            width: 50%;
        }
        .form-lt {
            padding-right: 10px;
        }
        .form-rt {
            padding-left: 10px;
        }
        .form-ct {
            width: 100%;
        }

        .btns {
            .btn {
                min-height: 50px;
                background-color: #333;
                color: #fff;
                font-size: 18px;
                padding: 0 0.8em;
                -webkit-transition: opacity 0.2s linear 0s;
                transition: opacity 0.2s linear 0s;
                width: 100%;
                @media (min-width: 992px) {
                    width: 350px;
                }
                &:hover {
                    background-color: #444;
                }
            }

            .info,
            .create-account-text {
                padding-left: 20px;
            }
        }
        &.step1 {
            .btns {
            }
        }

        // react select
        .react-select-container-custom {
            .select__control {
                border-color: #ccc;
                border-radius: 5px;
                background-color: #fdfdfd;
                &:hover {
                    border-color: #ccc;
                }

                &.select__control--is-focused,
                &.select__control--menu-is-open {
                    border-color: #000;
                    box-shadow: none;
                }

                .select__value-container {
                    padding-top: 0;
                    padding-bottom: 0;
                }

                .select__input-container {
                    margin: 0;
                    height: 48px;
                }
            }
            input {
                height: auto !important;
            }
        }
    }

    .upcoming-steps-view {
        > .head {
            border-bottom: 1px solid #d8d8d8;
            margin-bottom: 15px;
            padding-bottom: 5px;
        }
        .frac {
            margin-bottom: 15px;
            .head {
                margin-bottom: 4px;
            }
            .desc {
                color: #555;
            }
        }
    }

    .shipping-method-label {
        margin-bottom: 20px;
        .main {
            user-select: none;
            border: 2px solid #ccc;
            width: 100%;
            padding: 9px 15px;
            min-height: 65px;

            .round {
                height: 22px;
                width: 22px;
                border-radius: 50%;
                // background: #666;
                background: #ccc;

                &::after {
                    content: "";
                    height: 10px;
                    width: 10px;
                    border-radius: 50%;
                    background-color: #fff;
                    opacity: 0;
                }

                .head {
                    margin-bottom: 3px;
                }
            }
        }

        > input {
            &:checked {
                & + .main {
                    border-color: #333;
                    background-color: #efefef;

                    .round {
                        background: #333;
                        &::after {
                            opacity: 1;
                        }
                    }

                    .head {
                    }
                }
            }
        }
    }

    .form-credit-card {
        margin-bottom: 20px;
        > .inner {
            background: #efefef;
            padding: 25px;
            border-radius: 30px;
            @media (min-width: 768px) {
                max-width: 80%;
            }
        }
    }

    .credit-card-address-details {
    }

    #card-element-main {
        height: 48px;
    }
    .payment-card-element {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .change-address {
        color: #333;
        top: -1px;
    }

    .exp-field {
        width: 70%;
        padding-right: 7.5px;
    }
    .cvv-field {
        width: 30%;
        padding-left: 7.5px;
    }

    .st-form {
        label {
            margin-bottom: 3px;
            font-weight: 600;
            font-size: 13.5px;
        }
    }
    // for stripe
    .StripeElement {
        border-radius: 5px;
        border: 1px solid #ced4da;
        padding: 5px 15px;
        color: #333;
        font-size: 15px;
        cursor: text;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 40px;
        background-color: #fff;
        @media only screen and (min-width: 768px) {
            height: 48px;
        }
        transition: 0.3s;
        // empty stipe input
        &.StripeElement--empty {
        }

        // focus stipe input
        &.StripeElement--focus {
            border-color: #333;
            box-shadow: 0 0 1px 1px #333;
        }

        // invalid stipe input
        &.StripeElement--invalid {
            border-color: #e94f4f;
            color: #e94f4f;
            box-shadow: 0 0 1px 1px #e94f4f;
        }
    }
`;

export default CheckoutStepsContainer;
